'use client'
import type { ProductSimpleListSkeletonProps } from '@maestro/commerce-blocks/components/product-simple-list/product-simple-list.types'

import { ProductCardSkeleton } from '@maestro/commerce-blocks/components/product-card'

export default function ProductSimpleListSkeleton(
  props: ProductSimpleListSkeletonProps
) {
  const { length = 6, keyPrefix = 'product-simple-list-skeleton' } = props

  return (
    <ul className="product-simple-list">
      {Array.from({ length }).map((_, index) => (
        <li className="product-simple-list__item" key={`${keyPrefix}-${index}`}>
          <ProductCardSkeleton isCompact />
        </li>
      ))}
    </ul>
  )
}
